import type { AxiosResponse } from 'axios'

export default function extractData<T>({ data }: AxiosResponse<T>): T {
  return data
}
